import { Box, Stack } from '@mui/material'
import TreatmentFieldsBlock from 'components/cattles/treatmentPage/components/fields/TreatmentFieldsBlock'
import { useTreatmentForm } from 'components/cattles/treatmentPage/hooks/useTreatmentForm'
import { useTreatmentInitialState } from 'components/cattles/treatmentPage/hooks/useTreatmentInitialState'
import { TreatmentFormFields } from 'components/cattles/treatmentPage/types/types'
import { toUpdateTreatmentPayload } from 'components/cattles/treatmentPage/utils/treatmentSchemaDisplay'
import { useTreatmentMutation } from 'hook/mutations/useTreatmentSchemasMutations'
import { useEffect } from 'react'
import { fetchDiagnosesList } from 'store/cattlesSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { ButtonUI } from 'ui/buttons/ButtonUI'
import Drawer from 'ui/Drawer'

interface Props {
	open: boolean
	onClose: () => void
	editData?: Partial<TreatmentFormFields & { id: number }> | null
}

const TreatmentEditDrawer = ({ open, onClose, editData }: Props) => {
	const dispatch = useAppDispatch()
	const diagnosesList =
		useAppSelector(state => state.cattlesSlice.diagnosesList) ?? []
	const diagnosesListPending = useAppSelector(
		state => state.cattlesSlice.diagnosesListPending,
	)

	const initialState = useTreatmentInitialState(true, editData ?? undefined)
	const {
		setValue,
		currentFields,
		canSubmit,
		handleFormSubmit,
		shouldShowError,
		reset,
	} = useTreatmentForm(initialState, true)

	const { updateTreatmentSchema } = useTreatmentMutation()
	const field = currentFields[0]

	useEffect(() => {
		if (diagnosesList.length === 0) {
			dispatch(fetchDiagnosesList())
		}
	}, [dispatch, diagnosesList.length])

	useEffect(() => {
		if (open) reset()
	}, [open, reset])

	const onSubmit = (data: { treatments: TreatmentFormFields[] }) => {
		const first = data.treatments[0]
		if (!editData?.id) return

		updateTreatmentSchema.mutate(
			{
				id: editData.id,
				data: toUpdateTreatmentPayload(first),
			},
			{
				onSuccess: () => {
					reset()
					onClose()
				},
			},
		)
	}

	return (
		<Drawer
			open={open}
			onClose={onClose}
			title='Редактирование схемы лечения'
			anchor='right'
			width={520}
		>
			<Stack
				component='form'
				onSubmit={e => handleFormSubmit(e, onSubmit)}
				direction='column'
				gap='16px'
				margin='0px 24px'
				sx={{ minHeight: '100%' }}
			>
				{field && (
					<TreatmentFieldsBlock
						index={0}
						field={field}
						diagnosesList={diagnosesList}
						loading={diagnosesListPending}
						shouldShowError={shouldShowError}
						onChange={(fieldName, value) =>
							setValue(`treatments.${0}.${fieldName}`, value as never, {
								shouldDirty: true,
								shouldTouch: true,
							})
						}
					/>
				)}
				<Box sx={{ mt: 'auto', pb: '24px' }}>
					<ButtonUI
						type='submit'
						disabled={!canSubmit}
						sx={{ height: '56px', width: '100%' }}
					>
						Сохранить
					</ButtonUI>
				</Box>
			</Stack>
		</Drawer>
	)
}

export default TreatmentEditDrawer
